import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-password-toggle]';
const PLUGIN_NAME = 'PasswordToggle';

$(document).ready(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--password-toggle" */ './password-toggle'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/password-toggle/plugin--split.js